import {
  ADD_HIELOCO,
  DELETE_HIELOCO,
  FETCH_HIELOCOS_ERROR,
  FETCH_HIELOCOS_FINISH_LOADING,
  FETCH_HIELOCOS_NEXT_PAGE,
  FETCH_HIELOCOS_START_LOADING,
  FETCH_HIELOCOS_SUCCESS,
} from '../types/hielocos';

let initialState = {
  loading: false,
  error: null,
  items: [],
  currentPage: 0,
  totalPages: 0,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_HIELOCOS_START_LOADING:
      return {
        ...state,
        loading: true,
      };
    case FETCH_HIELOCOS_FINISH_LOADING:
      return {
        ...state,
        loading: false,
      };
    case FETCH_HIELOCOS_SUCCESS:
      return {
        ...state,
        ...payload,
        items: [...payload.items],
      };
    case FETCH_HIELOCOS_NEXT_PAGE:
      return {
        ...state,
        ...payload,
        items: [...state.items, ...payload.items],
      };
    case FETCH_HIELOCOS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };
    case ADD_HIELOCO:
      return {
        ...state,
        items: [payload.hieloco, ...state.items],
      };
    case DELETE_HIELOCO:
      const { id } = payload;
      const { items } = state;

      const index = items.findIndex((hieloco) => hieloco.id === id);
      items.splice(index, 1);

      return {
        ...state,
        items: [...items],
      };

    default:
      return state;
  }
}
